module.exports = __webpack_public_path__ + "img/home-billing.4ef50266.png";